import type {ReactElement} from 'react';
import {DROPDOWN_SIZE} from '@Components/dropdown-v2/dropdown.types';
import {CircularProgressLoader, LOADER_COLOR, LOADER_SIZE} from '@Components/circular-progress-loader';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';

interface DropdownSelectorCaretsProps {
  size?: DROPDOWN_SIZE;
  isDisabled?: boolean;
  isLoading?: boolean;
  isOpened?: boolean;
}

export function DropdownSelectorCarets({size = DROPDOWN_SIZE.SMALL, isOpened = false, isDisabled = false, isLoading = false}: DropdownSelectorCaretsProps): ReactElement<any> {
  const getIconSize = (): IconSize => {
    switch (size) {
      case DROPDOWN_SIZE.XSMALL:
        return IconSize.SIZE_ICON_16;
      case DROPDOWN_SIZE.SMALL:
        return IconSize.SIZE_ICON_20;
      case DROPDOWN_SIZE.MEDIUM:
        return IconSize.SIZE_ICON_24;
      default:
        return IconSize.SIZE_ICON_20;
    }
  };

  const getLoaderSize = (): LOADER_SIZE => {
    switch (size) {
      case DROPDOWN_SIZE.XSMALL:
        return LOADER_SIZE.XSMALL;
      case DROPDOWN_SIZE.SMALL:
        return LOADER_SIZE.SMALL;
      case DROPDOWN_SIZE.MEDIUM:
        return LOADER_SIZE.SMALL;
      default:
        return LOADER_SIZE.SMALL;
    }
  };
  if (isLoading) {
    return <CircularProgressLoader size={getLoaderSize()} color={LOADER_COLOR.DARK} />;
  }

  if (isOpened) {
    return <Icon icon="icon-caret-up" size={getIconSize()} className={`${isDisabled ? 'content-disabled' : ''}`} />;
  }

  return <Icon icon="icon-caret-down" size={getIconSize()} className={`${isDisabled ? 'content-disabled' : ''}`} />;
}
